import React from 'react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
export function LeadMagnet() {
  return <section className="py-24 bg-white" data-id="element-89">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-90">
        <div className="rounded-3xl p-8 md:p-16 flex flex-col md:flex-row items-center gap-12 border" style={{
        backgroundColor: '#074e3b10',
        borderColor: '#074e3b20'
      }} data-id="element-91">
          <div className="flex-1" data-id="element-92">
            <span className="inline-block px-4 py-1 rounded-full text-sm font-bold mb-6 text-white" style={{
            backgroundColor: '#074e3b'
          }} data-id="element-93">
              Free Guide
            </span>
            <h2 className="font-serif text-3xl font-bold text-stone-900 mb-4" data-id="element-94">
              Eat healthy without breaking the bank.
            </h2>
            <p className="text-lg text-stone-600 mb-8" data-id="element-95">
              Get our free grocery shopping guide with 50+ budget-friendly,
              nutritious staples and 5 easy recipes.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-96">
              <Input placeholder="First Name" className="bg-white" data-id="element-97" />
              <Input placeholder="Email Address" type="email" className="bg-white" data-id="element-98" />
              <Button className="shrink-0 whitespace-nowrap" data-id="element-99">
                Send It to Me
              </Button>
            </div>
            <p className="mt-4 text-xs text-stone-500" data-id="element-100">
              We respect your privacy. Unsubscribe at any time.
            </p>
          </div>

          <div className="w-full max-w-xs md:w-1/3 aspect-[3/4] bg-white rounded-2xl shadow-xl rotate-3 border-8 border-white flex items-center justify-center" data-id="element-101">
            {/* Book cover placeholder */}
            <div className="text-center p-8" data-id="element-102">
              <div className="text-6xl mb-4" data-id="element-103">🥗</div>
              <h3 className="font-serif font-bold text-xl text-stone-900" data-id="element-104">
                Grocery Guide
              </h3>
              <p className="text-sm text-stone-500 mt-2" data-id="element-105">
                The Well Balanced Way
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}